import { useWindowSize } from '@ori/presentation-hooks';
import { useEffect } from 'react';

import { useAppConfig, useTopAreaBanner } from '../context';
import { useSearchInput } from '../context/navigation';
import { useIsMobile } from './useIsMobile';

export enum TopNavClassName {
  default = 'top-nav',
  mobile = 'top-nav--is-mobile',
  withTopAreaBanner = 'top-nav--with-top-area-banner',
  searchInputVisible = 'top-nav--search-input-visible',
}

const getClassList = () => document.body.classList;

const addClassName = (className: TopNavClassName) => getClassList().add(className);

const removeClassName = (className: TopNavClassName) => getClassList().remove(className);

export const useManagedHeight = () => {
  const isMobile = useIsMobile();
  const { width } = useWindowSize();
  const { visible: bannerVisible } = useTopAreaBanner();
  const { isVisible: inputVisible } = useSearchInput();
  const { showSearchOnScroll } = useAppConfig();
  useEffect(() => {
    if (width) {
      addClassName(TopNavClassName.default);
      if (isMobile) {
        addClassName(TopNavClassName.mobile);
        if (showSearchOnScroll && inputVisible) {
          addClassName(TopNavClassName.searchInputVisible);
        } else {
          removeClassName(TopNavClassName.searchInputVisible);
        }
      } else {
        removeClassName(TopNavClassName.mobile);
      }
      if (bannerVisible) {
        addClassName(TopNavClassName.withTopAreaBanner);
      } else {
        removeClassName(TopNavClassName.withTopAreaBanner);
      }
    }
  }, [isMobile, bannerVisible, width, inputVisible, showSearchOnScroll]);
};
